import React, { useState, useContext, useEffect } from 'react'
import { Form, Row, Col, ListGroup } from 'react-bootstrap'
import axios from 'axios';

import api from '../../services/api'
import BtnLoader from '../buttons/loader/index.js'
import StoreContext from '../storage/context'
import errorHandlerShow from '../errorHandlerShow/index.js'

const FileUploader = ({
    setLgShow,
    setAlert,
    setShowAlert,
    fileName,
    fileId,
    delimiter,
    extensionFile,
    encoding,
    selectedData
}) => {
    const [file, setFile] = useState('')
    const [isRequesting, setIsRequesting] = useState(false); // Controla se o intervalo deve ser iniciado
    const [intervalId, setIntervalId] = useState(null); // Armazena o ID do intervalo

    // armazena o id gerado quando executa a lambda coedados-lambda-nco-us-east-1-portal-manual-move-file-{env}
    const [lambdaExecutionId, setLambdaExecutionId] = useState(null);
    const { pk_user, setToken, token } = useContext(StoreContext);
    const [loading, setLoading] = useState('');
    const [validationErrors, setValidationErrors] = useState([]);

    const [requestCount, setRequestCount] = useState(0);
    const maxRequests = 60;

    const extension_file = extensionFile.toLowerCase();
    const project_name = selectedData.project_name.toLowerCase();

    // Acceptable characters to have in a string
    const char_whitelist = /[^a-zA-Z0-9_]/g

    const handleFileChosen = async (event) => {
        event.preventDefault()
        setLoading(true)

        if (file) {
            // check if extension is correted
            const extensionSource = file.name.split('.').pop().toLowerCase()
            if (extension_file !== extensionSource) {
                setAlert({
                    header: 'Incompatibilidade no formato do arquivo',
                    message: 'O formato do arquivo cadastrado foi .' + extension_file + ', porém o fornecido foi .' + extensionSource,
                    type: 'danger',
                    options_btn: []
                })

                setShowAlert(true)
                setLoading(false)
            } else if (file.size > 5368709120) {
                console.log(`file.size do arquivo: ${file.size}`)
                setAlert({
                    header: 'Tamanho máximo do arquivo atingido.',
                    message: 'O arquivo a ser enviado não pode exceder 5GB. Sugerimos dividir o arquivo em partes menores para realizar o upload.',
                    type: 'danger',
                    options_btn: []
                });

                setShowAlert(true);
                setLoading(false);
            } else {
                try {
                    console.log(`file.size do arquivo: ${file.size}`)
                    setAlert({
                        header: 'Realizando o upload do arquivo',
                        message: 'O arquivo está sendo enviado para bucket da AWS para validação, progresso do upload: 0%',
                        type: 'warning',
                        options_btn: []
                    })

                    setShowAlert(true)

                    // Gerar URL
                    const preSignedUrlResponse = await api.get('manual-file/upload', {
                        params: {
                            'pk_user': pk_user,
                            'file_id': fileId,
                            'file_name': fileName.replace(" ", "_").replace(char_whitelist, ""),
                            'file_type': file.type,
                            'file_extension': extension_file,
                            'project_name': project_name,
                            "check_lambda_status": false
                        },
                        headers: { 'Authorization': token }
                    })

                    // Executar Upload para Bucket temporário
                    const response = await axios.put(preSignedUrlResponse.data.url, file, {
                        headers: {
                          'Content-Type': file.type,
                        },
                        onUploadProgress: (event) => {
                            const progress = Math.round((event.loaded * 100) / event.total);
                            console.log(`progress: ${progress}%`);
                            setAlert({
                                header: 'Carregando o arquivo para bucket da AWS.',
                                message: `O arquivo está sendo enviado para bucket da AWS para validação, progresso do upload: ${progress}%`,
                                type: 'warning',
                                options_btn: []
                            });
                        },
                    });

                    const fileKey = `${preSignedUrlResponse.data.file_path}/${preSignedUrlResponse.data.file_name}.${extensionSource}`

                    setAlert({
                        header: 'Iniciando validação do arquivo.',
                        message: `Finalizado o upload para área temporária, estamos validando se o layout do arquivo está conforme o cadastrado, aguarde...`,
                        type: 'warning',
                        options_btn: []
                    })

                    // Executa validacao do schema com relação ao schema cadastrado, somente quando não for Excel
                    const schemaValidationRes = await api.post('file-sample',
                        {
                            's3Bucket': preSignedUrlResponse.data.bucket_name,
                            'fileKey': fileKey,
                            'delimiter': delimiter,
                            "dynamoSystemName": "arquivos_manuais",
                            "dynamoEntityName": fileName,
                            "encoding": encoding,
                            "extension_file": extension_file
                        },
                        {
                            params: { "type-inference": "schema-validation", 'pk_user': pk_user },
                            headers: { 'Authorization': token }
                        }
                    )

                    setAlert({
                        header: 'Movendo arquivo para local definitivo.',
                        message: `Validação finalizada com sucesso, estamos movendo o arquivo para o local definitivo. Por favor, aguarde...`,
                        type: 'warning',
                        options_btn: []
                    })

                    // Tranferir arquivo para bucket de Ingestion
                    const callTransferFileResponse = await api.post('manual-file/upload',
                        {
                            'filePath': preSignedUrlResponse.data.file_path,
                            'fileName': preSignedUrlResponse.data.file_name,
                            'delimiter': delimiter,
                            'file_extension': extensionSource,
                            'project_name': project_name
                        },
                        {
                            params: { 'pk_user': pk_user },
                            headers: { 'Authorization': token },
                        }
                    )

                    if (callTransferFileResponse.status === 200) {
                        console.log('Requisição periódica concluída com sucesso!');
                        setLambdaExecutionId(callTransferFileResponse.data.lambda_execution_id); // Atualiza os dados recebidos
                        // Após o sucesso da requisição inicial, inicia o ciclo de requisições periódicas.
                        setIsRequesting(true);
                    }

                } catch (error) {
                    console.log(`Error das execuções da lambda: ${error}`)

                    errorHandlerShow(error, setToken, setAlert, setShowAlert)
                    setLoading(false)
                    document.getElementById("fileUploaded").value = ""

                    if ('response' in error) {
                        setValidationErrors(error.response.data.data)
                    }
                }
            }
        } else {
            setAlert({
                header: 'Ops... não está esquecendo de algo?',
                message: 'Por gentileza, adicione um arquivo ' + extensionFile + '.',
                type: 'danger',
                options_btn: []
            })
            // show alert with mensage
            setShowAlert(true)
            setLoading(false)
        }
    };


    // Função para requisições periódicas
    const periodicRequest = async () => {
        try {
            // Tranferir arquivo para bucket de Ingestion
            const triggerResponse = await api.get('manual-file/upload', {
                params: {
                    'pk_user': pk_user,
                    "check_lambda_status": true,
                    "lambda_execution_id": lambdaExecutionId
                },
                headers: { 'Authorization': token },
            })

            // Condição de parada: se os dados atenderem a uma condição, interromper as requisições
            if (triggerResponse.data.status === 'complete') {
                console.log('Condição atendida, parando as requisições.');
                setAlert({
                    header: 'Upload finalizado com sucesso.',
                    message: "O arquivo encontra-se armazenado na nuvem da AWS. Aguarde a execução agendada no Databricks para que os dados sejam refletidos no catálogo platform do Lakehouse.",
                    type: 'success',
                    options_btn: []
                })
                setShowAlert(true)
                setLgShow(false)
                setLoading(false)
                setIsRequesting(false); // Para o ciclo de requisições
                document.getElementById("fileUploaded").value = ""
            } else if (triggerResponse.data.status === 'error'){
                setAlert({
                    header: 'Ocorreu um erro ao mover o arquivo para bucket da ingestion.',
                    message: `Mensagem de erro retornada: ${triggerResponse.data.message}`,
                    type: 'danger',
                    options_btn: []
                })

                // show alert with mensage
                setShowAlert(true)
                setLoading(false)
                setIsRequesting(false); // Para o ciclo de requisições
                document.getElementById("fileUploaded").value = ""
            }

        } catch (error) {
            handleErrorIngestion(error);
        }
    };

    // UseEffect para iniciar as requisições periódicas após a primeira
    useEffect(() => {
        if (isRequesting) {
            try {
                // realiza a primeira requisição para consultar se o job já finalizou...
                periodicRequest();

                // Define o intervalo para executar a cada 30 segundos (30000 ms)
                const id = setInterval(() => {
                    try {
                        setRequestCount((prevCount) => {
                            if (prevCount >= maxRequests - 1) {
                                clearInterval(id); // Para o setInterval quando atingir o máximo
                                const error = "O número máximo de requisições foi atingido. Por favor, entre em contato com time do DA&Hub para suporte."
                                handleErrorIngestion(error);
                            }
                            return prevCount + 1;
                        });

                        periodicRequest(); // Chama a função a cada 30s
                    } catch (error) {
                        handleErrorIngestion(error);
                    }
                }, 15000);

                // Armazena o ID do intervalo
                setIntervalId(id);

            } catch (error) {
                handleErrorIngestion(error);
            }

        } else if (intervalId) {
            // Limpa o intervalo quando isRequesting for false
            clearInterval(intervalId);
            setIntervalId(null); // Reseta o ID do intervalo
        }

        // Limpa o intervalo ao desmontar o componente
        return () => {
           if (intervalId) { clearInterval(intervalId);}
        };
    }, [isRequesting]); // Dispara quando o estado `isRequesting` for alterado


    const handleErrorIngestion = (error) => {
        console.error('Ocorreu um erro ao mover o arquivo para bucket da ingestion.', error);
        setAlert({
            header: 'Ocorreu um erro ao mover o arquivo para bucket da ingestion.',
            message: `Mensagem de erro retornada: ${error}`,
            type: 'danger',
            options_btn: []
        })

        // show alert with mensage
        setShowAlert(true)
        setLoading(false)
        setIsRequesting(false); // Para o ciclo de requisições
        document.getElementById("fileUploaded").value = ""
    };

    return (
        <Form noValidate>
            <Row >
                <Col md>
                    <Form.Group controlId="upload_csv">
                        <Form.Label><strong>Certifique que o arquivo possua cabeçalho.</strong></Form.Label>
                        <Form.Control
                            id="fileUploaded"
                            type="file"
                            accept="*"
                            onChange={event => setFile(event.target.files[0])}
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-3">
                <Col md>
                    <BtnLoader
                        loading={loading}
                        messageNotLoading="Processar"
                        messageLoading="Processando"
                        style={"btn-loader-145px mf-register-load-field"}
                        variant={"primary"}
                        onClick={event => handleFileChosen(event)}
                        hasOnClick={true}
                    />
                </Col>
            </Row>
            {validationErrors.length > 0 ?
                <Row className="mb-3">
                    <h5>Erros de Schema</h5>
                    <ListGroup>
                        {validationErrors.map(item => (<ListGroup.Item>{item}</ListGroup.Item>))}
                    </ListGroup>
                </Row>
                : null}
        </Form >
    )
}

export default FileUploader;